import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
const _excluded = ["animateOnMount", "children"];
import styled, { css } from 'foundations-theming/utils';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { AbstractPageSection } from '../AbstractPageSection/AbstractPageSection';
import { StickyFooter } from '../StickyFooter/StickyFooter';
import { useEffect, useState } from 'react';

/** See `StickyFooter` for prop descriptions. */
import { jsx as _jsx } from "react/jsx-runtime";
export const getFixedStickyFooterStyles = props => {
  const {
    theme,
    $cssStyles
  } = props;
  const styles = css(["background-color:", ";border-block-start:", " solid ", ";box-shadow:none;padding-block:", ";line-height:normal;", ";"], theme.color['fill-surface-recessed'], theme.borderWidth[100], theme.color['border-core-subtle'], theme.space[500], Object.assign({}, $cssStyles));
  return styles;
};
const FixedStickyFooter = styled(_ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(StickyFooter, Object.assign({}, rest));
}).withConfig({
  displayName: "FixedSaveBar__FixedStickyFooter"
})(["", ";"], props => getFixedStickyFooterStyles(props));
export const FixedSaveBar = _ref2 => {
  let {
      animateOnMount = true,
      children
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  /**
   * FixedSaveBar should only be rendered full width when the body does not have the `space-sword--max-width` class.
   * @see https://github.com/HubSpotEngineering/UIComponents/blob/272f8a583642b1cee22f6f54737c8599d107390e/UIComponents/static/js/panel/UIFixedSaveBar.tsx#L24-L28
   */
  const shouldRenderFullWidth = () => {
    return !document.body.classList.contains('space-sword--max-width');
  };
  const [fullWidth, setFullWidth] = useState(() => shouldRenderFullWidth());
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setFullWidth(shouldRenderFullWidth());
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    return () => observer.disconnect();
  }, [setFullWidth]);
  return /*#__PURE__*/_jsx(FixedStickyFooter, Object.assign({
    animateOnMount: animateOnMount
  }, rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'FixedSaveBar',
    children: /*#__PURE__*/_jsx(AbstractPageSection, {
      fullWidth: fullWidth,
      centered: true,
      children: children
    })
  }));
};
FixedSaveBar.displayName = 'FixedSaveBar';